/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolFileResponse,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeCsvRequest,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeRequest,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponse,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateRequest,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateResponse,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopCsvRequest,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataRequest,
  PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PerformanceDetailsCompRate<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PerformanceDetailsCompRate
   * @name DetailsCompRateCreate
   * @request POST:/performance/details/comp-rate
   */
  detailsCompRateCreate = (
    data: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateResponse, any>({
      path: `/performance/details/comp-rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsCompRate
   * @name DetailsCompRateOverTimeCreate
   * @request POST:/performance/details/comp-rate/over-time
   */
  detailsCompRateOverTimeCreate = (
    data: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeResponse, any>({
      path: `/performance/details/comp-rate/over-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsCompRate
   * @name DetailsCompRateTopMarketplaceCreate
   * @request POST:/performance/details/comp-rate/top-marketplace
   */
  detailsCompRateTopMarketplaceCreate = (
    data: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopDataResponse, any>({
      path: `/performance/details/comp-rate/top-marketplace`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsCompRate
   * @name DetailsCompRateTopMarketplaceCsvCreate
   * @request POST:/performance/details/comp-rate/top-marketplace/csv
   */
  detailsCompRateTopMarketplaceCsvCreate = (
    data: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateTopCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/details/comp-rate/top-marketplace/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsCompRate
   * @name DetailsCompRateOverTimeCsvCreate
   * @request POST:/performance/details/comp-rate/over-time/csv
   */
  detailsCompRateOverTimeCsvCreate = (
    data: PerfCommerceDetailsPerfDetailsCompRateProtocolsGetComplianceRateOverTimeCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/details/comp-rate/over-time/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
